import React = require('react');
import { FiUser } from 'react-icons/fi';
import { FiLogOut } from 'react-icons/fi/';
import { Link } from 'react-router-dom';
import { FaHandsHelping } from 'react-icons/fa';
import { useClickOutside } from '../../../../../../hooks/clickOutside';
import { useState } from 'react';

export const MenuDropdown = ({ actions }) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = React.createRef();
  useClickOutside(wrapperRef, () => {
    setShowDropdown(false);
  });

  const handleOnClick = () => {
    setShowDropdown(!showDropdown)
  }

  return (
    <div className="nav-elements pointer" style={{ position: 'relative' }}><a onClick={handleOnClick}>
      <FiUser className="portal-top-nav__icon"/>Account</a>
      {showDropdown && (
        <div style={{
          position: 'absolute',
          minWidth: '160px',
          zIndex: '100',
          right: '0',
          top: '40px',
          boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
          backgroundColor: '#FFFFFF',
          textAlign: 'left'
        }} ref={wrapperRef}>
          <div className="pointer" style={{ margin: '5px' }} onClick={handleOnClick}>
            <a onClick={actions.auth.logout}>
              <FiLogOut className="portal-top-nav__icon"/> Logout
            </a>
          </div>
          <div style={{ margin: '5px' }} onClick={handleOnClick}>
            <Link to={'/account/manage'}>
              <FaHandsHelping className="portal-top-nav__icon"/>Accessibility and Support
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}
